
<div class="modal-header">
  <h4 class="modal-title pull-left">{{actionLabel}}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="$event.preventDefault()">
      <fieldset class="form-body row g-0">
        <div class="col-md-12 m-b">
          <label class="col-sm-12 pb-1">Nome:<sup class="text-danger">*</sup></label>
          <input id="name" class="form-control" formControlName="name" />
          <app-field-message [field]="fieldMessageRequired('name')" [erros]="fieldErros('name')"></app-field-message>
        </div>
      </fieldset>
    
      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-danger m-r-xs" type="button" (click)="onExcluir()">Excluir</button>
          <button class="btn btn-primary" type="submit">Salvar</button>
        </div>
      </div>
    </form> 
  </div>
  <app-loading [loader]="isLoading"></app-loading>